import axiosInstance from 'common/js/axios-service'

export function getSeatInfo() {
  return axiosInstance.request({
    url: 'getseat'
  })
}
